import { dashboard } from "../../../store/dashboardSlice";
import { Icon } from "@iconify/react";
import { Avatar, Box, Button, Drawer, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import navConfig from "./config";
import NavSection from "../../../components/nav-section";
import Scrollbar from "../../../components/scrollbar";
import useResponsive from "../../../hooks/useResponsive";
import Badge from "@mui/material/Badge";
import axios from "axios";
import PropTypes from "prop-types";
import { fetchAccountDetails } from "../../../store/accountSlice";

const NAV_WIDTH = 280;

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  // const dispatch = useDispatch();
  // const { data } = useSelector((state) => state.dashboard);

  // useEffect(() => {
  //   dispatch(dashboard());
  // }, []);

  // const {
  //   customer_name,
  //   client_email,
  // } = data;

  const isDesktop = useResponsive("up", "lg");
  const navigate = useNavigate();
  const handleLogOut = () => {
    axios.get("/meonsupport/support/logout").then((response) => {
      if (response.data === "Logged out") {
        sessionStorage.removeItem("token");
        navigate("/login");
      }
    });
  };

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const [accountDetails, setAccountDetails] = useState({
    customer_name: '',
    customer_id: '',
    products: '',
    client_status: ''
  });

  const dispatch = useDispatch();
  const {
    data,
    customer_name,
    customer_id,
    products,
    contact_person,
    contact_email,
    contact_number,
    session_response,
    session_flag,
    status,
    error
  } = useSelector((state) => state.account)

  useEffect(() => {
    dispatch(fetchAccountDetails());
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      if (session_flag) {
        // setSessionResponse(session_response);
        // setSessionFlag(true);
      } else {
        setAccountDetails(data);
        // setEmail(contact_email);
        // setContactPerson(contact_person);
        // setContactNumber(contact_number);
      }
    }
  }, [data]);


  // useEffect(() => {
  //   const fetchAccountDetails = async () => {
  //     try {
  //       const response = await fetch('/meonsupport/account_detail', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       });
  //       const data = await response.json();
  //       setAccountDetails(data);
  //     } catch (error) {
  //       console.error("Error fetching account details:", error);
  //     }
  //   };

  //   fetchAccountDetails();
  // }, []);

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      backgroundColor: "#44b700",
      color: "#44b700",
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "ripple 1.2s infinite ease-in-out",
        border: "1px solid currentColor",
        content: '""',
      },
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1,
      },
      "100%": {
        transform: "scale(2.4)",
        opacity: 0,
      },
    },
  }));

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: "background.default",
              borderRightStyle: "dashed",
              border: "1px solid rgb(199, 199, 199)",
            },
          }}
        >
          <Scrollbar
            sx={{
              height: 1,
              "& .simplebar-content": {
                height: 1,
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 5,
                mb: 3,
              }}
            >
              <NavLink to="/">
                <img src="/assets/images/meon-logo.png" width={150} alt="" />
              </NavLink>
            </Box>

            <NavSection data={navConfig} />

            <hr style={{ margin: "50px 10px" }} />

            <Stack
              direction={"row"}
              spacing={1}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Box className="sideBarImg">
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  variant="dot"
                >
                  <Avatar alt={accountDetails.email} src="" />
                </StyledBadge>
              </Box>
              <Stack>
                <h4>{accountDetails.customer_name}</h4>
                <p style={{ fontSize: "small" }}>{accountDetails.email}</p>
              </Stack>
            </Stack>
            <Stack marginTop={2}>
              <Button
                onClick={handleLogOut}
                startIcon={
                  <Icon
                    icon="ic:sharp-logout"
                    color="white"
                    width="24"
                    height="24"
                  />
                }
                style={{
                  width: "50%",
                  textAlign: "center",
                  margin: "auto",
                  fontWeight: 500,
                }}
                variant="contained"
              >
                Log Out
              </Button>
            </Stack>
          </Scrollbar>
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          <Scrollbar
            sx={{
              height: 1,
              "& .simplebar-content": {
                height: 1,
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 5,
                mb: 5,
              }}
            >
              <NavLink to="/">
                <img src="/assets/images/meon-logo.png" width={150} alt="" />
              </NavLink>
            </Box>
            <NavSection data={navConfig} />
            <hr style={{ margin: "50px 10px" }} />
            <Stack
              direction={"row"}
              spacing={2}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Box className="sideBarImg">
                <StyledBadge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  variant="dot"
                >
                  <Avatar alt={accountDetails.email} src="" />
                </StyledBadge>
              </Box>
              <Stack spacing={1}>
                <h4 style={{ wordBreak: "break-word" }}>
                  {accountDetails.customer_name}
                </h4>
                <p style={{ wordBreak: "break-word" }}>{accountDetails.email}</p>
              </Stack>
            </Stack>
            <Stack marginTop={1}>
              <Button
                onClick={handleLogOut}
                startIcon={
                  <Icon
                    icon="ic:sharp-logout"
                    color="white"
                    width="24"
                    height="24"
                  />
                }
                style={{
                  width: "50%",
                  textAlign: "center",
                  margin: "auto",
                }}
                variant="contained"
              >
                Log Out
              </Button>
            </Stack>
          </Scrollbar>
        </Drawer>
      )}
    </Box>
  );
}
